<template>
  <div>
    <b-modal
      v-model="modalShow"
      size="xl"
      id="modal-detail"
      centered
      hide-footer
      content-class="content-modal-class"
      header-class="header-modal-class"
    >
      <template #modal-header>
        <span class="title-modal">รายละเอียด</span
        ><a class="link-remove-info">นำออกข้อมูล</a>
      </template>
      <b-table
        responsive
        id="table-detail"
        class="text-center table-detail mb-0"
        :fields="fields"
        :items="items"
        :busy="isBusy"
        show-empty
        empty-text="ไม่พบข้อมูล"
      >
        <template #head(createdTime)="data">
          <div class="w-100 border-right">
            <span>{{ data.field.label }}</span>
          </div>
        </template>

        <template #head(note)="data">
          <div class="w-100 border-right">
            <span>{{ data.field.label }}</span>
          </div>
        </template>

        <template #head(originalQuantity)="data">
          <div class="w-100 border-right">
            <span>{{ data.field.label }}</span>
          </div>
        </template>

        <template #head(updateQuantity)="data">
          <div class="w-100 border-right">
            <span>{{ data.field.label }}</span>
          </div>
        </template>

        <template #head(createdBy)="data">
          <div class="w-100 border-right">
            <span>{{ data.field.label }}</span>
          </div>
        </template>

        <template v-slot:cell(createdTime)="data">
          <p class="mb-0">
            {{ new Date(data.item.createdTime) | moment($formatDateTime) }}
          </p>
        </template>
      </b-table>
      <b-row class="no-gutters px-3 px-sm-0">
        <b-col class="d-flex m-auto ml-2">
          <b-button class="cancel-button" @click="hide">ยกเลิก</b-button>
        </b-col>
        <b-col class="form-inline justify-content-end">
          <div class="d-sm-flex m-3">
            <b-pagination
              v-model="filter.PageNo"
              :total-rows="rows"
              :per-page="filter.PerPage"
              class="m-md-0 page-item"
              @change="pagination"
              align="center"
            ></b-pagination>
          </div>

          <b-form-select
            class="mr-sm-3 select-page"
            v-model="filter.PerPage"
            @change="hanndleChangePerpage"
            :options="pageOptions"
          ></b-form-select>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    productId: {
      required: true,
      type: [Number, String],
    },
  },
  data() {
    return {
      modalShow: false,
      isBusy: false,
      filter: {
        search: "",
        status: [0, 1],
        PageNo: 1,
        PerPage: 10,
        startDate: null,
        endDate: null,
        branchId: 0,
        productId: 0,
      },
      rows: 0,
      items: [],
      fields: [
        {
          key: "createdTime",
          label: "วันที่ และ เวลา",
        },
        {
          key: "note",
          label: "รายละเอียด",
        },
        {
          key: "originalQuantity",
          label: "จำนวน (ชิ้น)",
        },
        {
          key: "updateQuantity",
          label: "คงเหลือ (ชิ้น)",
        },
        {
          key: "createdBy",
          label: "โดย",
        },
      ],
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
    };
  },
  validations: {},
  methods: {
    pagination(page) {
      this.filter.PageNo = page;
      this.getProductInventoryLog();
    },
    hanndleChangePerpage(value) {
      this.filter.PageNo = 1;
      this.filter.PerPage = value;
      this.getProductInventoryLog();
    },
    getProductInventoryLog: async function () {
      this.filter.productId = this.productId;
      this.isBusy = true;
      await this.axios
        .post(`${this.$baseUrl}/product/Stock/${this.productId}`, this.filter)
        .then((data) => {
          this.rows = data.detail.stockLog.count;
          this.items = data.detail.stockLog.stockLogList;
          this.isBusy = false;
        });
    },
    show: async function () {
      this.modalShow = true;
      this.filter.PageNo = 1;
      await this.getProductInventoryLog();
    },
    hide() {
      this.modalShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .table > tbody > tr > td {
  min-width: 150px;
}
.product-name {
  width: 300px;
  text-align: left;
}
a:hover {
  color: #b41bb4;
  text-decoration: underline;
  cursor: pointer;
}
.title-modal {
  font-weight: bold;
  color: black;
}
.cancel-button {
  background-color: white;
  width: 150px;
}
.link-remove-info {
  color: #b41bb4;
  text-decoration: underline;
}
/deep/ .header-modal-class {
  background: #5b57a547;
}
/deep/ .content-modal-class {
  border: 0;
}
// style table detail in modal
/deep/ .table-detail td {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
/deep/ .table-detail th {
  padding-left: 0px !important;
  padding-right: 0px !important;
  border-bottom: 0.5px solid #d8dbe0;
}
/deep/ .table-detail tr {
  border-bottom: 0.5px solid #d8dbe0;
}
</style>
